import type { Config, EventType } from "../../../../engine/types";

/** What an event changes on court, in a few words ("first to 7", "next point wins at 10-10"); empty when the name already says it all. */
export function eventChanges(config: Config, event: EventType): string {
  const parts: string[] = [];
  const target = event.target ?? config.target;
  if (event.target !== undefined && event.target !== config.target) parts.push(`first to ${event.target}`);
  if (event.winBy2 === false) parts.push(`next point wins at ${target - 1}-${target - 1}`);
  return parts.join(", ");
}
